import { css } from '@rxdi/lit-html';

export const options = {
  backdropClose: true,
  style: css`
    .wrapper {
      position: absolute;
      top: 0;
      left: 0;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    @keyframes scale {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    @keyframes blur {
      to {
        backdrop-filter: blur(5px);
      }
    }

    .backdrop {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      pointer-events: all;
      z-index: 10;
      animation: blur 0.3s linear forwards;
    }

    .content {
      z-index: 20;
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: all;
      animation-name: scale;
      animation-duration: 300ms;
    }
  `,
};
